import type { AxiosRequestConfig } from 'axios';
import {
  bulkMarkAttendance,
  summarizeSession,
  updateSessionNotes,
  updateSessionTopic,
} from '../generated/sportSchool';
import type { SyncRequestContext, SyncTransport } from './types';

/**
 * Per-request options for background sync:
 * - `X-School-Id` / `X-Active-Role` come from the entry (the interceptor in `api.ts` keeps explicitly set values);
 * - `skipAuthRedirect` — a 401 during background sync must never redirect to the login page; the engine renews
 *   the token silently and keeps the entries.
 */
function requestOptions(ctx: SyncRequestContext): AxiosRequestConfig {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-School-Id': ctx.schoolId,
  };
  if (ctx.activeRole) headers['X-Active-Role'] = ctx.activeRole;
  return { headers, skipAuthRedirect: true };
}

/** Real transport: generated Orval client functions over the shared axios instance. */
export const apiSyncTransport: SyncTransport = {
  async bulkMarkAttendance(ctx, entries) {
    return bulkMarkAttendance(ctx.schoolId, { entries }, requestOptions(ctx));
  },
  async updateNotes(ctx, sessionId, body) {
    await updateSessionNotes(ctx.schoolId, sessionId, body, requestOptions(ctx));
  },
  async updateTopic(ctx, sessionId, body) {
    await updateSessionTopic(ctx.schoolId, sessionId, body, requestOptions(ctx));
  },
  async summarize(ctx, sessionId, body) {
    await summarizeSession(ctx.schoolId, sessionId, body, requestOptions(ctx));
  },
};
